/**
 * 导入数据-无动画
 */
 export const importEmpty = (item,EmptyAnimation) => {
    let pipe = item.emptyAnimation
    if (pipe.dataType == 'Bool') {//管道流水 Bool类型
        let boolData = {}
        let realData = {
            formulaType: 'empty',
            tag: '',
            unit: '',
            realTagData: [
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                },
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                }
            ]
        }
        let boolTagData = []
        if (pipe.boolData.formulaType == 'empty') {//Bool类型 运算符为 '无'
            boolData = {
                formulaType: pipe.boolData.formulaType,
                tag: pipe.boolData.tag,
                tagValue: pipe.boolData.tagValue,
                boolTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }
        if (pipe.boolData.formulaType == '&') {//Bool类型 运算符为 '&'
            let arr = pipe.boolData.tag.split('&')
            arr.forEach(arrv => {
                boolTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            boolData = {
                formulaType: pipe.boolData.formulaType,
                tag: '',
                tagValue: pipe.boolData.tagValue,
                boolTagData: boolTagData
            }
        }
        if (pipe.boolData.formulaType == '||') {//Bool类型 运算符为 '||'
            let arr = pipe.boolData.tag.split('||')
            arr.forEach(arrv => {
                boolTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            boolData = {
                formulaType: pipe.boolData.formulaType,
                tag: '',
                tagValue: pipe.boolData.tagValue,
                boolTagData: boolTagData
            }
        }
        if (pipe.boolData.formulaType == '!') {//Bool类型 运算符为 '!'
            boolData = {
                formulaType: pipe.boolData.formulaType,
                tag: pipe.boolData.tag,
                tagValue: pipe.boolData.tagValue,
                boolTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }

        EmptyAnimation = {
            dataType: pipe.dataType,
            boolData: boolData,
            realData: realData,
            tagDrawer: false,
            tagRadio: '',
        }
    }
    if (pipe.dataType == 'Real') {//管道流水 Real类型
        let boolData = {
            formulaType: 'empty',
            tag: '',
            tagValue: '',
            boolTagData: [
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                },
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                }
            ]
        }
        let realData = {}
        let realTagData = []
        if (pipe.realData.formulaType == 'empty') {//Real类型 运算符为 '无'
            realData = {
                formulaType: pipe.realData.formulaType,
                tag: pipe.realData.tag,
                unit: pipe.realData.unit,
                realTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }
        if (pipe.realData.formulaType == '+') {//Real类型 运算符为 '+'
            let arr = pipe.realData.tag.split('+')
            arr.forEach(arrv => {
                realTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            realData = {
                formulaType: pipe.realData.formulaType,
                tag: '',
                unit: pipe.realData.unit,
                realTagData: realTagData
            }
        }
        if (pipe.realData.formulaType == '-') {//Real类型 运算符为 '-'
            let arr = pipe.realData.tag.split('-')
            arr.forEach(arrv => {
                realTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            realData = {
                formulaType: pipe.realData.formulaType,
                tag: '',
                unit: pipe.realData.unit,
                realTagData: realTagData
            }
        }

        EmptyAnimation = {
            dataType: pipe.dataType,
            boolData: boolData,
            realData: realData,
            tagDrawer: false,
            tagRadio: '',
        }
    }
    return EmptyAnimation
}